import { render } from "./PedidoAmostraLote.vue?vue&type=template&id=23eb3bc4&scoped=true"
import script from "./PedidoAmostraLote.vue?vue&type=script&lang=js"
export * from "./PedidoAmostraLote.vue?vue&type=script&lang=js"

import "./PedidoAmostraLote.vue?vue&type=style&index=0&id=23eb3bc4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23eb3bc4"]])

export default __exports__